import { ScorePayload } from '@/types'
import HttpRepository from '../HttpRepository'
import Repository from '../Repository'

export interface IBookingRepository {
  getBooking: (id: string, type: string, language?: string) => Promise<any>
  createScore: (id: string, payload: ScorePayload) => Promise<any>
}

export default class BookingRepository extends HttpRepository {
  async getBooking(id: string, type: string, language?: string): Promise<any> {
    return await Repository.get(`${this.endpoint}/${id}`, { params: { type, language } })
  }

  async createScore(id: string, payload: ScorePayload): Promise<any> {
    return await Repository.post(`${this.endpoint}/${id}/scores`, payload)
  }
}
